/* eslint-disable */
import { SvgIcon, SvgIconProps } from '@mui/material'
/* eslint-disable */

export const ArrowDownIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M6.24315 8.8418L12 14.6523L17.7568 8.8418L18.6316 9.72601L12 16.4207L5.36841 9.72601L6.24315 8.8418Z" />
  </SvgIcon>
)

export const ArrowUpIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M17.7568 15.1571L12 9.34655L6.24315 15.1571L5.36841 14.2729L12 7.57812L18.6316 14.2729L17.7568 15.1571Z" />
  </SvgIcon>
)

export const LeftArrowFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M14 7V17L9 12L14 7Z" />
  </SvgIcon>
)

export const RightArrowFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M10 17V7L15 12L10 17Z" />
  </SvgIcon>
)

export const LeftArrowStrokeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M15 6L9 12L15 18L14 19L7 12L14 5L15 6Z" />
  </SvgIcon>
)

export const RightArrowStrokeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M7 6L13 12L7 18L8 19L15 12L8 5L7 6Z" />
  </SvgIcon>
)

export const TableSortArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 76 76">
    <path d="M22 32H54L38 48L22 32Z" />
  </SvgIcon>
)
